// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/components/Box/EditModal.css */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background-color: white;
  padding: 24px;
  border-radius: 8px;
  width: 350px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
}

.modal-content.edit-modal {
  width: 400px;
}

.modal-content.modal-large-tabs {
  width: 600px;
  max-width: 95vw;
}

.modal-content h2 {
  margin: 0 0 20px 0;
  color: #2C3E50;
  font-size: 18px;
  font-weight: 600;
}

/* Tabs */
.modal-tabs {
  display: flex;
  gap: 4px;
  margin-bottom: 20px;
  border-bottom: 2px solid #ECF0F1;
  padding-bottom: 0;
}

.tab-btn {
  padding: 10px 20px;
  border: none;
  background-color: transparent;
  color: #7F8C8D;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  border-bottom: 2px solid transparent;
  margin-bottom: -2px;
  transition: all 0.2s;
}

.tab-btn:hover {
  color: #34495E;
}

.tab-btn.active {
  color: #3498DB;
  border-bottom-color: #3498DB;
}

/* Form fields */
.form-fields {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.form-group label {
  color: #34495E;
  font-size: 14px;
  font-weight: 500;
}

.modal-content input {
  display: block;
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #BDC3C7;
  border-radius: 4px;
  font-size: 14px;
  box-sizing: border-box;
  pointer-events: auto;
  opacity: 1;
}

.modal-content input:focus {
  outline: none;
  border-color: #3498DB;
  box-shadow: 0 0 0 2px rgba(52, 152, 219, 0.2);
}

/* Buttons */
.button-group {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 24px;
  padding-top: 16px;
  border-top: 1px solid #ECF0F1;
}

.button-group button {
  padding: 10px 20px;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.2s;
}

.cancel-btn {
  border: 1px solid #BDC3C7;
  background-color: white;
  color: #7F8C8D;
}

.cancel-btn:hover {
  background-color: #ECF0F1;
}

.save-btn {
  border: none;
  background-color: #27AE60;
  color: white;
}

.save-btn:hover {
  background-color: #219A52;
}

/* Income tab content */
.incomes-tab-content {
  min-height: 300px;
}

.incomes-tab-content .button-group {
  margin-top: 16px;
}

/* Financials tab content */
.financials-tab-content {
  min-height: 300px;
}

.financials-tab-content .button-group {
  margin-top: 16px;
}

/* Entity tab styling */
.tab-btn-entity.active {
  color: #F39C12;
  border-bottom-color: #F39C12;
}

/* Tax tab styling */
.tab-btn-tax.active {
  color: #8E44AD;
  border-bottom-color: #8E44AD;
}

/* Tax tab content */
.tax-tab-content {
  min-height: 300px;
}

.tax-tab-content .button-group {
  margin-top: 16px;
}

/* ============================================
   Person Info Form (enriched form for individuals)
   ============================================ */

.person-info-form {
  max-height: 60vh;
  overflow-y: auto;
  padding-right: 8px;
}

.person-info-form .form-section {
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 1px solid #ECF0F1;
}

.person-info-form .form-section:last-of-type {
  border-bottom: none;
}

.person-info-form .form-section h4 {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: #7F8C8D;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin: 0 0 16px 0;
}

.person-info-form .section-icon {
  font-size: 18px;
}

.person-info-form .form-row {
  display: flex;
  gap: 16px;
}

.person-info-form .form-row .form-group {
  flex: 1 1;
}

.person-info-form select {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #BDC3C7;
  border-radius: 6px;
  font-size: 14px;
  background: white;
  cursor: pointer;
}

.person-info-form select:focus {
  outline: none;
  border-color: #FF6F61;
  box-shadow: 0 0 0 2px rgba(255, 111, 97, 0.2);
}

/* Status cards (marital status) */
.person-info-form .status-cards {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.person-info-form .status-card {
  flex-grow: 0;
  flex-shrink: 0;
  flex-basis: calc(20% - 7px);
  min-width: 80px;
  padding: 10px 6px;
  border: 2px solid #ECF0F1;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  background: white;
}

.person-info-form .status-card:hover {
  border-color: #FF6F61;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.person-info-form .status-card.selected {
  border-color: #FF6F61;
  background: linear-gradient(180deg, white 0%, rgba(255, 111, 97, 0.05) 100%);
  box-shadow: 0 0 0 3px rgba(255, 111, 97, 0.2);
}

.person-info-form .status-icon {
  font-size: 18px;
  margin-bottom: 4px;
}

.person-info-form .status-label {
  font-weight: 500;
  color: #2C3E50;
  font-size: 11px;
}

/* Children control */
.person-info-form .children-control {
  display: flex;
  align-items: center;
  gap: 12px;
  background: #F8FAFC;
  padding: 8px 16px;
  border-radius: 8px;
  width: fit-content;
}

.person-info-form .children-btn {
  width: 32px;
  height: 32px;
  border: 2px solid #BDC3C7;
  background: white;
  border-radius: 50%;
  font-size: 18px;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #7F8C8D;
}

.person-info-form .children-btn:hover:not(:disabled) {
  border-color: #FF6F61;
  color: #FF6F61;
}

.person-info-form .children-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.person-info-form .children-btn.plus:hover:not(:disabled) {
  background: #FF6F61;
  border-color: #FF6F61;
  color: white;
}

.person-info-form .children-count {
  font-size: 22px;
  font-weight: 700;
  color: #2C3E50;
  min-width: 36px;
  text-align: center;
}

/* Checkbox */
.person-info-form .checkbox-group {
  margin-top: 12px;
}

.person-info-form .checkbox-label {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  padding: 10px 14px;
  background: #FFF9F8;
  border-radius: 8px;
  border: 1px solid #FFE5E2;
  transition: all 0.2s;
}

.person-info-form .checkbox-label:hover {
  background: #FFE5E2;
}

.person-info-form .checkbox-label input[type="checkbox"] {
  width: 18px;
  height: 18px;
  cursor: pointer;
  accent-color: #FF6F61;
}

/* Fiscal parts display */
.person-info-form .fiscal-parts-display {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 18px;
  background: linear-gradient(135deg, #FF6F61 0%, #FF8A80 100%);
  border-radius: 10px;
  margin-top: 16px;
}

.person-info-form .fiscal-parts-display .label {
  color: rgba(255, 255, 255, 0.9);
  font-size: 13px;
  font-weight: 500;
}

.person-info-form .fiscal-parts-display .parts {
  color: white;
  font-size: 20px;
  font-weight: 700;
}

/* Employment cards */
.person-info-form .employment-cards {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.person-info-form .employment-card {
  flex-grow: 0;
  flex-shrink: 0;
  flex-basis: calc(33.333% - 6px);
  min-width: 100px;
  padding: 12px 8px;
  border: 2px solid #ECF0F1;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  background: white;
}

.person-info-form .employment-card:hover {
  border-color: #3498DB;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.person-info-form .employment-card.selected {
  border-color: #3498DB;
  background: linear-gradient(180deg, white 0%, rgba(52, 152, 219, 0.05) 100%);
  box-shadow: 0 0 0 3px rgba(52, 152, 219, 0.2);
}

.person-info-form .employment-icon {
  font-size: 22px;
  margin-bottom: 4px;
}

.person-info-form .employment-label {
  font-weight: 600;
  color: #2C3E50;
  font-size: 11px;
}

.person-info-form .employment-description {
  font-size: 9px;
  color: #95A5A6;
  margin-top: 2px;
}

/* Responsive */
@media (max-width: 600px) {
  .person-info-form .form-row {
    flex-direction: column;
  }

  .person-info-form .status-card {
    flex-grow: 0;
    flex-shrink: 0;
    flex-basis: calc(33.333% - 6px);
  }

  .person-info-form .employment-card {
    flex-grow: 0;
    flex-shrink: 0;
    flex-basis: calc(50% - 4px);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Box/EditModal.css"],"names":[],"mappings":"AAAA,qCAAqC;AACrC;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA,SAAS;AACT;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,6BAA6B;EAC7B,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oCAAoC;EACpC,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,4BAA4B;AAC9B;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,sBAAsB;EACtB,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,uBAAuB;AACvB;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,uBAAuB;AACvB;EACE,cAAc;EACd,4BAA4B;AAC9B;;AAEA,oBAAoB;AACpB;EACE,cAAc;EACd,4BAA4B;AAC9B;;AAEA,oBAAoB;AACpB;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;iDAEiD;;AAEjD;EACE,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA,kCAAkC;AAClC;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,YAAyB;EAAzB,cAAyB;EAAzB,2BAAyB;EACzB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,qBAAqB;EACrB,4EAA4E;EAC5E,6CAA6C;AAC/C;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA,aAAa;AACb;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,qBAAqB;AACvB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,6DAA6D;EAC7D,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,YAA6B;EAA7B,cAA6B;EAA7B,+BAA6B;EAC7B,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,qBAAqB;EACrB,4EAA4E;EAC5E,6CAA6C;AAC/C;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;AACjB;;AAEA,eAAe;AACf;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,YAA6B;IAA7B,cAA6B;IAA7B,+BAA6B;EAC/B;;EAEA;IACE,YAAyB;IAAzB,cAAyB;IAAzB,2BAAyB;EAC3B;AACF","sourcesContent":["/* src/components/Box/EditModal.css */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.modal-content {\n  background-color: white;\n  padding: 24px;\n  border-radius: 8px;\n  width: 350px;\n  max-height: 90vh;\n  overflow-y: auto;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);\n}\n\n.modal-content.edit-modal {\n  width: 400px;\n}\n\n.modal-content.modal-large-tabs {\n  width: 600px;\n  max-width: 95vw;\n}\n\n.modal-content h2 {\n  margin: 0 0 20px 0;\n  color: #2C3E50;\n  font-size: 18px;\n  font-weight: 600;\n}\n\n/* Tabs */\n.modal-tabs {\n  display: flex;\n  gap: 4px;\n  margin-bottom: 20px;\n  border-bottom: 2px solid #ECF0F1;\n  padding-bottom: 0;\n}\n\n.tab-btn {\n  padding: 10px 20px;\n  border: none;\n  background-color: transparent;\n  color: #7F8C8D;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  border-bottom: 2px solid transparent;\n  margin-bottom: -2px;\n  transition: all 0.2s;\n}\n\n.tab-btn:hover {\n  color: #34495E;\n}\n\n.tab-btn.active {\n  color: #3498DB;\n  border-bottom-color: #3498DB;\n}\n\n/* Form fields */\n.form-fields {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.form-group {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.form-group label {\n  color: #34495E;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.modal-content input {\n  display: block;\n  width: 100%;\n  padding: 10px 12px;\n  border: 1px solid #BDC3C7;\n  border-radius: 4px;\n  font-size: 14px;\n  box-sizing: border-box;\n  pointer-events: auto;\n  opacity: 1;\n}\n\n.modal-content input:focus {\n  outline: none;\n  border-color: #3498DB;\n  box-shadow: 0 0 0 2px rgba(52, 152, 219, 0.2);\n}\n\n/* Buttons */\n.button-group {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  margin-top: 24px;\n  padding-top: 16px;\n  border-top: 1px solid #ECF0F1;\n}\n\n.button-group button {\n  padding: 10px 20px;\n  border-radius: 4px;\n  font-size: 14px;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.cancel-btn {\n  border: 1px solid #BDC3C7;\n  background-color: white;\n  color: #7F8C8D;\n}\n\n.cancel-btn:hover {\n  background-color: #ECF0F1;\n}\n\n.save-btn {\n  border: none;\n  background-color: #27AE60;\n  color: white;\n}\n\n.save-btn:hover {\n  background-color: #219A52;\n}\n\n/* Income tab content */\n.incomes-tab-content {\n  min-height: 300px;\n}\n\n.incomes-tab-content .button-group {\n  margin-top: 16px;\n}\n\n/* Financials tab content */\n.financials-tab-content {\n  min-height: 300px;\n}\n\n.financials-tab-content .button-group {\n  margin-top: 16px;\n}\n\n/* Entity tab styling */\n.tab-btn-entity.active {\n  color: #F39C12;\n  border-bottom-color: #F39C12;\n}\n\n/* Tax tab styling */\n.tab-btn-tax.active {\n  color: #8E44AD;\n  border-bottom-color: #8E44AD;\n}\n\n/* Tax tab content */\n.tax-tab-content {\n  min-height: 300px;\n}\n\n.tax-tab-content .button-group {\n  margin-top: 16px;\n}\n\n/* ============================================\n   Person Info Form (enriched form for individuals)\n   ============================================ */\n\n.person-info-form {\n  max-height: 60vh;\n  overflow-y: auto;\n  padding-right: 8px;\n}\n\n.person-info-form .form-section {\n  margin-bottom: 24px;\n  padding-bottom: 16px;\n  border-bottom: 1px solid #ECF0F1;\n}\n\n.person-info-form .form-section:last-of-type {\n  border-bottom: none;\n}\n\n.person-info-form .form-section h4 {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 14px;\n  color: #7F8C8D;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  margin: 0 0 16px 0;\n}\n\n.person-info-form .section-icon {\n  font-size: 18px;\n}\n\n.person-info-form .form-row {\n  display: flex;\n  gap: 16px;\n}\n\n.person-info-form .form-row .form-group {\n  flex: 1;\n}\n\n.person-info-form select {\n  width: 100%;\n  padding: 10px 12px;\n  border: 1px solid #BDC3C7;\n  border-radius: 6px;\n  font-size: 14px;\n  background: white;\n  cursor: pointer;\n}\n\n.person-info-form select:focus {\n  outline: none;\n  border-color: #FF6F61;\n  box-shadow: 0 0 0 2px rgba(255, 111, 97, 0.2);\n}\n\n/* Status cards (marital status) */\n.person-info-form .status-cards {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.person-info-form .status-card {\n  flex: 0 0 calc(20% - 7px);\n  min-width: 80px;\n  padding: 10px 6px;\n  border: 2px solid #ECF0F1;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  background: white;\n}\n\n.person-info-form .status-card:hover {\n  border-color: #FF6F61;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n}\n\n.person-info-form .status-card.selected {\n  border-color: #FF6F61;\n  background: linear-gradient(180deg, white 0%, rgba(255, 111, 97, 0.05) 100%);\n  box-shadow: 0 0 0 3px rgba(255, 111, 97, 0.2);\n}\n\n.person-info-form .status-icon {\n  font-size: 18px;\n  margin-bottom: 4px;\n}\n\n.person-info-form .status-label {\n  font-weight: 500;\n  color: #2C3E50;\n  font-size: 11px;\n}\n\n/* Children control */\n.person-info-form .children-control {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  background: #F8FAFC;\n  padding: 8px 16px;\n  border-radius: 8px;\n  width: fit-content;\n}\n\n.person-info-form .children-btn {\n  width: 32px;\n  height: 32px;\n  border: 2px solid #BDC3C7;\n  background: white;\n  border-radius: 50%;\n  font-size: 18px;\n  font-weight: bold;\n  cursor: pointer;\n  transition: all 0.2s;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #7F8C8D;\n}\n\n.person-info-form .children-btn:hover:not(:disabled) {\n  border-color: #FF6F61;\n  color: #FF6F61;\n}\n\n.person-info-form .children-btn:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n.person-info-form .children-btn.plus:hover:not(:disabled) {\n  background: #FF6F61;\n  border-color: #FF6F61;\n  color: white;\n}\n\n.person-info-form .children-count {\n  font-size: 22px;\n  font-weight: 700;\n  color: #2C3E50;\n  min-width: 36px;\n  text-align: center;\n}\n\n/* Checkbox */\n.person-info-form .checkbox-group {\n  margin-top: 12px;\n}\n\n.person-info-form .checkbox-label {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  cursor: pointer;\n  padding: 10px 14px;\n  background: #FFF9F8;\n  border-radius: 8px;\n  border: 1px solid #FFE5E2;\n  transition: all 0.2s;\n}\n\n.person-info-form .checkbox-label:hover {\n  background: #FFE5E2;\n}\n\n.person-info-form .checkbox-label input[type=\"checkbox\"] {\n  width: 18px;\n  height: 18px;\n  cursor: pointer;\n  accent-color: #FF6F61;\n}\n\n/* Fiscal parts display */\n.person-info-form .fiscal-parts-display {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 14px 18px;\n  background: linear-gradient(135deg, #FF6F61 0%, #FF8A80 100%);\n  border-radius: 10px;\n  margin-top: 16px;\n}\n\n.person-info-form .fiscal-parts-display .label {\n  color: rgba(255, 255, 255, 0.9);\n  font-size: 13px;\n  font-weight: 500;\n}\n\n.person-info-form .fiscal-parts-display .parts {\n  color: white;\n  font-size: 20px;\n  font-weight: 700;\n}\n\n/* Employment cards */\n.person-info-form .employment-cards {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.person-info-form .employment-card {\n  flex: 0 0 calc(33.333% - 6px);\n  min-width: 100px;\n  padding: 12px 8px;\n  border: 2px solid #ECF0F1;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  background: white;\n}\n\n.person-info-form .employment-card:hover {\n  border-color: #3498DB;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n}\n\n.person-info-form .employment-card.selected {\n  border-color: #3498DB;\n  background: linear-gradient(180deg, white 0%, rgba(52, 152, 219, 0.05) 100%);\n  box-shadow: 0 0 0 3px rgba(52, 152, 219, 0.2);\n}\n\n.person-info-form .employment-icon {\n  font-size: 22px;\n  margin-bottom: 4px;\n}\n\n.person-info-form .employment-label {\n  font-weight: 600;\n  color: #2C3E50;\n  font-size: 11px;\n}\n\n.person-info-form .employment-description {\n  font-size: 9px;\n  color: #95A5A6;\n  margin-top: 2px;\n}\n\n/* Responsive */\n@media (max-width: 600px) {\n  .person-info-form .form-row {\n    flex-direction: column;\n  }\n\n  .person-info-form .status-card {\n    flex: 0 0 calc(33.333% - 6px);\n  }\n\n  .person-info-form .employment-card {\n    flex: 0 0 calc(50% - 4px);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
